import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

// Anchor component (for <a> tag)
const LinkAnchor = React__default.forwardRef((_a, ref) => {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  return jsx("a", Object.assign({
    ref: ref
  }, props, {
    role: "link",
    children: children
  }));
});

export { LinkAnchor };
